module.exports = __webpack_public_path__ + "static/media/2.b2a68b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/2.png
// module id = 1094
// module chunks = 0